import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import styles from "./Navbar.module.css";

import logo from "../../assets/TS LOGO.jpg"; // or .jpg, .svg depending on your file

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);

  return (
    <nav className={`${styles.navbar} ${scrolled ? styles.scrolled : ""}`}>
      <div className={styles.navContainer}>
        <div className={styles.logoContainer}>
          <div className={styles.logoAndText}>
            <img src={logo} alt="Throne Stone Logo" className={styles.logoImage} />
            <div className={styles.logo}>
              <span className={styles.highlight}>THRONE</span> STONE
            </div>
          </div>
          <p className={styles.tagline}>Bespoke Stonework in Sri Lanka Since 2000</p>
        </div>
        
        <div className={styles.hamburger} onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        <ul className={`${styles.navLinks} ${mobileMenuOpen ? styles.active : ''}`}>
          <li><NavLink to="/" end className={({ isActive }) => isActive ? styles.active : ""} onClick={() => setMobileMenuOpen(false)}>Home</NavLink></li>
          <li><NavLink to="/gallery" className={({ isActive }) => isActive ? styles.active : ""} onClick={() => setMobileMenuOpen(false)}>Portfolio</NavLink></li>
          <li><NavLink to="/stones" className={({ isActive }) => isActive ? styles.active : ""} onClick={() => setMobileMenuOpen(false)}>Our Stones</NavLink></li>
          <li><NavLink to="/about" className={({ isActive }) => isActive ? styles.active : ""} onClick={() => setMobileMenuOpen(false)}>About Us</NavLink></li>
          
          <li className={styles.ctaButton}><NavLink to="/contact" className={styles.quoteBtn} onClick={() => setMobileMenuOpen(false)}>Contact Us</NavLink></li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;